import { ProgressBar, Icon, Button } from "@/components";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./styles.scss";

import { Question } from "./Question";
import { useAuth } from "@/contexts/auth-context";
import { useAppSelector } from "@/redux/hooks";

export default function Activity() {
  const location = useLocation();

  const cachedActivities = location.state?.cachedActivities || [];
  const [questionIndex, setQuestionIndex] = useState(0);

  const { data, error, loading } = useAppSelector(
    (state) => state.activityLesson
  );

  const { updateGameTimeStamp, gameTimeStamp } = useAuth();

  const { level_id, lesson_id } = useParams();
  const activity = cachedActivities;

  const completion_percent = activity
    ? (questionIndex * 100) / (activity.length - 1)
    : 0;

  const lessons = useMemo(() => activity ?? [], [activity]);
  const currentQuestion = useMemo(
    () => lessons[questionIndex],
    [questionIndex, lessons]
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (data === null) {
      navigate(`/activity/level/${level_id}`);
    }
  }, []);

  return (
    <div className="single_activity--container">
      {currentQuestion.activityType === "ChatActivity" ? null : (
        <div className="top">
          <Button variant="neutral" onClick={() => navigate(-2)}>
            <Icon name="close" />
          </Button>
          <ProgressBar percent={completion_percent} />
        </div>
      )}
      {data && (
        <Question
          question={currentQuestion}
          handleNextQuestion={() => {
            setQuestionIndex((index) => {
              if (index === lessons.length - 1) {
                updateGameTimeStamp({ ...gameTimeStamp, end: Date.now() });
                navigate(
                  `/activity/level/${level_id}/lesson/${lesson_id}/brief/trivia-activity/complete`
                );
                return 0;
              } else {
                return index + 1;
              }
            });
          }}
        />
      )}
    </div>
  );
}
